import React from 'react';
import BaseTable from '../common/BaseTable';
import handleKpiTargetClick from '../../src/kpis';

export default function KpiTargets({ rows, projectId }) {
  const headCells = [
    { key: 'name', label: 'Name' },
    { key: 'value', label: 'Value' },
  ];

  const handleRowClick = (kpi) => {
    handleKpiTargetClick(projectId, kpi.kpi_target_id);
  };

  return (
    <BaseTable
      rows={rows}
      headCells={headCells}
      handleRowClick={handleRowClick}
    />
  );
}
